import { render, staticRenderFns } from "./workDynamics.vue?vue&type=template&id=230f6660&scoped=true"
import script from "./workDynamics.vue?vue&type=script&lang=js"
export * from "./workDynamics.vue?vue&type=script&lang=js"
import style0 from "./workDynamics.vue?vue&type=style&index=0&id=230f6660&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230f6660",
  null
  
)

export default component.exports